<template>
  <Modal @hidemodal="closeWelcome" size="lg" :lowheader="true">
    <div slot="content" v-if="alias==='kidsModeWelcome'">
      <div class="welcome-screen-title">KIDS MODE IS ON</div>
      <div class="row">
        <div class="col-sm-6">
          <img src="../assets/img/welcome/welcome-kids-mode.png" alt="welcome feature" class="welcome-feature-image">
        </div>
        <div class="col-sm-6 flex flex-h-center flex-column">
          <p class="text-lg">{{$lang.messages.kid.welcome.text_item_1}}</p>
          <ul class="m-0 mb-2 text-lg">
            <li>{{$lang.messages.kid.welcome.list_item_1}}</li>
            <li>{{$lang.messages.kid.welcome.list_item_2}}</li>
            <li>{{$lang.messages.kid.welcome.list_item_3}}</li>
          </ul>
          <p class="text-lg mb-2">{{$lang.messages.kid.welcome.text_item_2}}</p>
        </div>
      </div>
      <div class="text-center">
        <button class="btn btn-main -shadow -min-width" @click="dontShowWelcome">{{ $lang.messages.got_it }}</button>
      </div>
    </div>
    <div slot="content" class="welcome-block" v-if="alias === 'installWelcome'">
      <div class="welcome-mobile slider-screen" v-if="isMobileView">
        <div class="welcome-title">
          {{ $lang.messages.kid.welcome_to }}
          <div class="text-center mt-1">
            <img alt="logo" src="../assets/img/logo-new.svg" class="logo">
          </div>
        </div>
        <VueSlickCarousel ref="carousel" class="add-child-slider"
                          @beforeChange="beforeWelcomeSlideChange"
                          :infinite=false :swipe=true :adaptiveHeight=false :dots=true :arrows=false>
          <div class="slider-item welcome-feature pb-0" v-for="(feature, index) in installWelcomeSlidesData" :key="index">
            <div class="welcome-feature-title">{{feature.title}}</div>
            <div class="welcome-feature-text">{{feature.text}}</div>
            <img :src="imgUrl(feature.image)" alt="welcome feature" class="m-auto">
          </div>
        </VueSlickCarousel>
      </div>
      <div class="welcome-desktop" v-else>
        <h1 class="text-center p-1 mb-0 mt-0">{{ $lang.messages.kid.welcome_to }} {{ $lang.messages.kids_mode }}</h1>
        <div class="welcome-features mt-0">
          <div class="welcome-feature pb-0" v-for="(feature, index) in installWelcomefeatures" :key="index">
            <div class="welcome-feature-title">{{feature.title}}</div>
            <div class="welcome-feature-text">{{feature.text}}</div>
            <img :src="imgUrl(feature.image)" alt="welcome feature" class="mt-auto">
          </div>
        </div>
        <div class="text-center" v-if="$route === '/'">
          <div>
            <button class="btn btn-main btn-huge -shadow" @click="$route.path === '/' ? $router.push(isPremium ? '/dashboard' : '/freeDashboard'): $emit('hidemodal')">
              {{ $lang.messages.lets_go }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="alias === 'dashboardFreeWelcome'" slot="content">
      <div class="welcome-screen-title">Parent Dashboard Free</div>
      <div class="text-center text-lg mb-1">{{$lang.messages.free_dashboard.welcome.title}}</div>
      <VueSlickCarousel ref="carousel" class="add-child-slider"
                        :infinite="false" :adaptiveHeight="false" :arrows="false" :dots="true" v-if="isMobileView"
                        @beforeChange="beforeWelcomeSlideChange">
        <div v-for="slide in dashboardFreeWelcomeSlidesData" :key="slide.label">
          <div class="mt-1">
            <img :src="slide.img" alt="welcome feature" class="welcome-feature-image m-auto mb-05">
            <div class="text-center text-lg mt-1 mb-2"> {{slide.label}}</div>
          </div>
        </div>
      </VueSlickCarousel>
      <div class="welcome-features" v-else>
        <div class="welcome-feature" v-for="feature in dashboardFreeWelcomeSlidesData" :key="feature.label">
          <img :src="feature.img" alt="welcome feature" class="welcome-feature-image"/>
          <div class="text-lg text-center mt-auto">{{feature.label}}</div>
        </div>
      </div>
    </div>
    <div v-if="alias === 'dashboardProWelcome'" slot="content">
      <div class="welcome-screen-title">Parent Dashboard Pro</div>
      <VueSlickCarousel class="add-child-slider"  v-if="isMobileView"
                        :infinite="false" :adaptiveHeight="false" :dots="true" ref="carousel"
                        @beforeChange="beforeWelcomeSlideChange">
        <div v-for="slide in dashboardProWelcomeSlidesData" :key="slide.label">
          <img :src="slide.img" alt="image" class="w-100">
          <div class="text-center text-lg mt-1 mb-2"> {{slide.label}}</div>
        </div>
      </VueSlickCarousel>
      <div class="row mb-1 mt-3 ml-1 mr-1" v-else>
        <div v-for="slide in dashboardProWelcomeSlidesData" :key="slide.label" class="col-sm-4">
          <img :src="slide.img" alt="image" class="w-100">
          <div class="text-center text-lg mt-1 mb-2"> {{slide.label}}</div>
        </div>
      </div>
    </div>
    <div slot="content" v-if="alias != 'kidsModeWelcome'">
      <div class="welcome-slider-navigation-footer text-right" v-if="isMobileView">
        <button class="btn-prev" v-if="currentWelcomeSlideIndex !== 0" @click="$refs.carousel.prev()"></button>
        <button class="btn btn-main -shadow" v-if="currentWelcomeSlideIndex !== slidesLength - 1" @click="$refs.carousel.next()">
          {{ $lang.messages.next }}
        </button>
        <button v-else class="btn btn-main -shadow" @click="dontShowWelcome">
          {{ $lang.messages.got_it }}
        </button>
      </div>
      <div class="text-center mb-2" v-else>
        <button class="btn btn-main -shadow -min-width" @click="dontShowWelcome">{{ $lang.messages.got_it }}</button>
      </div>
    </div>
  </Modal>
</template>

<script>

import {mapState} from "vuex";
import VueSlickCarousel from "vue-slick-carousel";
import Modal from "@/components/common/Modal";
import {reportEvent} from "@/helpers/utils";

const images = require.context('../assets/img/welcome/', false, /\.png$/)

export default {
  name: 'WelcomeScreens',
  props: ['alias', 'title'],
  data: function () {
    return {
      isMobileView: window.innerWidth <= 768,
      currentWelcomeSlideIndex: 0,
      dashboardProWelcomeSlidesData: [
        {
          img: require('../assets/img/welcome/welcome-dashboard-1.png'),
          label: this.$lang.messages.dashboard.welcome_screen.feature_text_1
        },
        {
          img: require('../assets/img/welcome/welcome-dashboard-2.png'),
          label: this.$lang.messages.dashboard.welcome_screen.feature_text_2
        }, {
          img: require('../assets/img/welcome/welcome-dashboard-3.png'),
          label: this.$lang.messages.dashboard.welcome_screen.feature_text_3
        },
      ],
      dashboardFreeWelcomeSlidesData: [
        {
          img: require('../assets/img/welcome/welcome-parent-mode-1.png'),
          label: this.$lang.messages.free_dashboard.welcome.feature_1
        },
        {
          img: require('../assets/img/welcome/welcome-parent-mode-2.png'),
          label: this.$lang.messages.free_dashboard.welcome.feature_2
        }
      ],
      installWelcomeSlidesData: [
        {
          image: 'welcome-1.png',
          title: 'Keep Your Kids Safe'
        },
        {
          image: 'welcome-2.png',
          title: 'Personalize The Look'
        },
        {
          image: 'welcome-3.png',
          title: 'Customize The Settings'
        },
        {
          image: 'welcome-4.png',
          title: 'Keep Track Of Your Kids'
        }
      ],
      installWelcomefeatures: [
        {
          image: 'welcome-desktop-1.png',
          title: 'For Parents',
          text: 'Keep your privacy while kids are using your devices'
        },
        {
          image: 'welcome-desktop-2.png',
          title: 'For Kids',
          text: 'Give kids a safe zone to browse with content you have approved'
        },
      ]
    }
  },
  mounted() {
    reportEvent('dialog', {name: this.alias, action: 'open'})
  },
  methods: {
    beforeWelcomeSlideChange(oldSlideIndex, newSlideIndex) {
      this.currentWelcomeSlideIndex = newSlideIndex;
    },
    dontShowWelcome(){
      localStorage.setItem(this.alias, true);
      if (this.alias === 'dashboardFreeWelcome') {
        this.$store.commit('hidePMWelcome', true);
      }
      reportEvent('dialog', {name: this.alias, action: 'click'})
      this.$emit('hidewelcome')
    },
    closeWelcome(){
      reportEvent('dialog', {name: this.alias, action: 'close'})
      this.$emit('hidewelcome')
    },
    imgUrl: function (path) {
      return images('./' + path)
    },
  },
  computed: {
    slidesLength(){
      return this[this.alias + 'SlidesData'].length
    },
    isAndroid(){
      return window.Android
    },
    ...mapState({
      isPremium: state => state.accountData.isPremium,
    }),
  },
  components: { VueSlickCarousel, Modal }
}

</script>

<style lang="scss">

@import "../assets/styles/helpers";

  .welcome-screen-title {
    font-size: 30px;
    font-weight: 800;
    margin-bottom: 4px;
    text-align: center;
  }
</style>
